import React from 'react';
import AAccordion from 'antd-mobile/lib/accordion';



export default class Accordion extends AAccordion {}
